import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import MonitorResult from '../views/MonitorResult.vue'
import PointsRecharge from '../views/PointsRecharge.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { title: '数据看板', requiresAuth: true }
      },
      {
        path: 'monitor-result',
        name: 'monitor-result',
        component: MonitorResult,
        meta: { title: '监控结果', requiresAuth: true }
      },
      {
        path: 'points-recharge',
        name: 'points-recharge',
        component: PointsRecharge,
        meta: { title: '积分充值', requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else if (to.matched.some(record => record.meta.guest) && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
